const defaultMaxFileSize = 35; // MB

export const FileSizeLimit = {
  video: Number(process.env.REACT_APP_MAX_FILE_SIZE_MB) || defaultMaxFileSize,
  image: Number(process.env.REACT_APP_MAX_FILE_SIZE_MB) || defaultMaxFileSize,
}

export const FileStorage = {
  filesystem: 'filesystem',
  s3: 's3',
}